/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "../common/Select";
import StyledTextField from "../common/StyledTextField";
import BaseButton from "../common/BaseButton";
import { useTheme } from "@material-ui/core/styles";
import { Grid, Button } from "@material-ui/core";
import styled from "styled-components";
import {
  resetCarrierManagementFilters,
  updateFilters,
} from "../../slices/carrierManagementFiltersSlice";
import { searchCarriers } from "../../slices/carrierManagementSlice";
import types from "../../helpers/types";
import AddNewCarrierButton from "./AddNewCarrierButton";

const StyledWrapperGridItem = styled(Grid)`
  background-color: ${(props) => props.theme.palette.background.lightGrey};
  flex: 0 0 auto !important;
  padding: 16px;

  .MuiFormControl-marginDense {
    margin-bottom: 0;
    margin-top: 0;
  }
`;

const StyledFilterGridItem = styled(Grid)`
  padding-right: 0 !important;
  padding-left: 8px !important;
  padding-bottom: 10px !important;
`;

const StyledLinkButton = styled(({ theme, ...props }) => <Button {...props} />)`
  color: ${(props) => props.theme.palette.link.main} !important;
  text-decoration: underline !important;
`;

const StyledGridHeaderItem = styled(Grid)`
  flex: 0 0 100%;
`;

const CarrierManagementFilters = () => {
  const carrierManagementFilters = useSelector(
    (state) => state.carrierManagementFilters
  );
  const dispatch = useDispatch();
  const theme = useTheme();

  const carrierTier = useSelector((state) => {
    return state.carrierManagementFilters.carrierTier;
  });

  const carrierTierHandleChange = ({ target: { value } }) => {
    dispatch(
      updateFilters({
        carrierManagementFilters: { carrierTier: value },
      })
    );
  };

  const [carrierName, setCarrierName] = useState(
    carrierManagementFilters.carrierName ?? ""
  );
  const carrierNameHandleChange = ({ target: { value } }) => {
    setCarrierName(value);
    dispatch(
      updateFilters({
        carrierManagementFilters: { carrierName: value },
      })
    );
  };

  const [contactName, setContactName] = useState(
    carrierManagementFilters.contactName ?? ""
  );
  const contactNameHandleChange = ({ target: { value } }) => {
    setContactName(value);
    dispatch(
      updateFilters({
        carrierManagementFilters: { contactName: value },
      })
    );
  };

  const [carrierOrganization, setCarrierOrganization] = useState(
    carrierManagementFilters.carrierOrganization ?? ""
  );
  const carrierOrganizationHandleChange = ({ target: { value } }) => {
    setCarrierOrganization(value);
    dispatch(
      updateFilters({
        carrierManagementFilters: { carrierOrganization: value },
      })
    );
  };

  const handleSearch = () => {
    dispatch(searchCarriers());
  };

  const handleClearSearch = () => {
    setCarrierName("");
    setContactName("");
    setCarrierOrganization("");
    dispatch(resetCarrierManagementFilters());
    dispatch(searchCarriers());
  };

  return (
    <>
      <StyledWrapperGridItem item theme={theme}>
        <Grid container spacing={4} alignItems="center">
          <StyledFilterGridItem item>
            <StyledGridHeaderItem item component="h5">
              Search for a carrier:
            </StyledGridHeaderItem>
          </StyledFilterGridItem>
          <StyledFilterGridItem item>
            <Select
              label="Carrier tier"
              selectedValue={carrierTier}
              options={types.carrierTiers}
              width={200}
              handleChange={carrierTierHandleChange}
              inputId="carrier-tier"
            />
          </StyledFilterGridItem>
          <StyledFilterGridItem item>
            <StyledTextField
              label="Carrier name"
              variant="outlined"
              fullWidth={true}
              value={carrierName}
              style={{ width: "200px" }}
              onChange={carrierNameHandleChange}
              inputProps={{
                maxLength: 2048,
                "data-testid": "carrier-name",
              }}
            />
          </StyledFilterGridItem>
          <StyledFilterGridItem item>
            <StyledTextField
              label="Contact name"
              variant="outlined"
              fullWidth={true}
              value={contactName}
              style={{ width: "200px" }}
              onChange={contactNameHandleChange}
              inputProps={{
                maxLength: 2048,
                "data-testid": "contact-name",
              }}
            />
          </StyledFilterGridItem>
          <StyledFilterGridItem item>
            <StyledTextField
              label="Carrier organization"
              variant="outlined"
              fullWidth={true}
              value={carrierOrganization}
              style={{ width: "200px" }}
              onChange={carrierOrganizationHandleChange}
              inputProps={{
                maxLength: 2048,
                "data-testid": "carrier-organization",
              }}
            />
          </StyledFilterGridItem>
          <StyledFilterGridItem item>
            <BaseButton onClick={handleSearch} data-testid="btn-search">
              SEARCH
            </BaseButton>
          </StyledFilterGridItem>
          <StyledFilterGridItem item>
            <StyledLinkButton
              theme={theme}
              onClick={handleClearSearch}
              data-testid="btn-clear"
            >
              Clear Search
            </StyledLinkButton>
          </StyledFilterGridItem>
          <StyledFilterGridItem item>
            <AddNewCarrierButton />
          </StyledFilterGridItem>
        </Grid>
      </StyledWrapperGridItem>
    </>
  );
};

export default CarrierManagementFilters;
